import styled from "styled-components";
import { breakpoints } from "styles/constants/breakpoints";
import { Button } from "components/atoms/button/button";

export const WrapperButton = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  width: 100%;

  @media ${breakpoints.tablet} {
    margin: 30px 0 20px 0;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  @media ${breakpoints.laptop} {
    flex-direction: row;
  }
`;

export const SelectRoleCTA = styled(Button)`
  width: 100%;
  @media ${breakpoints.tablet} {
    width: auto;
  }
`;
